import {IAvailabilitiesState, initialAvailabilitiesState} from '@app/core/store/state/availabilities.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {AvailabilitiesActions, EAvailabilitiesActions} from '@app/core/store/actions/availabilities.actions';

export const availabilitiesReducers = (
	state = initialAvailabilitiesState,
	action: AvailabilitiesActions | ErrorActions,
): IAvailabilitiesState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
			};
		}
		case EAvailabilitiesActions.GetApprovedAvailabilities: {
			return {
				...state,
				isLoadingApprovedAvailabilities: true,
			};
		}
		case EAvailabilitiesActions.GetApprovedAvailabilitiesSuccess: {
			return {
				...state,
				isLoadingApprovedAvailabilities: false,
				approvedAvailabilities: action.availabilities,
				approvedPagination: action.pagination,
			};
		}
		case EAvailabilitiesActions.GetUserAvailabilities: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EAvailabilitiesActions.GetUserAvailabilitiesSuccess: {
			return {
				...state,
				isLoading: false,
				availabilities: action.availabilities,
			};
		}
		case EAvailabilitiesActions.GetAvailabilities: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EAvailabilitiesActions.GetAvailabilitiesSuccess: {
			return {
				...state,
				isLoading: false,
				availabilities: action.availabilities,
			};
		}
		case EAvailabilitiesActions.PostAvailability: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EAvailabilitiesActions.PostAvailabilitySuccess: {
			return {
				...state,
				isLoading: false,
			};
		}
		case EAvailabilitiesActions.DeleteAvailability: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EAvailabilitiesActions.DeleteAvailabilitySuccess: {
			return {
				...state,
				isLoading: false,
				availabilities: state.availabilities.filter(a => a.id !== action.availability.id),
				approvedAvailabilities: state.approvedAvailabilities.filter(a => a.id !== action.availability.id),
			};
		}
		case EAvailabilitiesActions.ApproveAvailabilitySuccess: {
			return {
				...state,
				availabilities: state.availabilities.filter(a => a.id !== action.availability.id),
			};
		}
		default:
			return state;
	}
};
